import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";

import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent';

const app = createApp(App);

app.use(router);

app.mount("#app");

void CookieConsent.run({
    guiOptions: {
        consentModal: {
            layout: "box",
            position: "bottom right"
        }
    },

    categories: {
        necessary: {
            enabled: true,
            readOnly: true
        },

        external: {}
    },

    language: {
        default: "de",

        translations: {
            de: {
                consentModal: {
                    title: "Cookies & externe Inhalte",
                    description:
                        "Diese Website verwendet externe Inhalte wie Google Maps.",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Nur notwendige"
                },

                preferencesModal: {
                    title: "Einstellungen",
                    acceptAllBtn: "Alle akzeptieren",
                    acceptNecessaryBtn: "Nur notwendige",
                    savePreferencesBtn: "Speichern",
                    closeIconLabel: "Schließen",

                    sections: [
                        {
                            title: "Notwendige Cookies",
                            description:
                                "Diese Cookies sind für die Funktion der Website erforderlich.",

                            linkedCategory: "necessary"
                        },
                        {
                            title: "Externe Inhalte",
                            description:
                                "Diese Inhalte stammen von Drittanbietern wie Google Maps.",

                            linkedCategory: "external"
                        }
                    ]
                }
            }
        }
    }
})
